import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { useGetClient } from "../hooks/useGetClient.js";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {

  const {
    client,
    loading: loadingClient,
    error: errorClient,
    fetchClient,
  } = useGetClient();

  const [isConnected, setIsConnected] = useState(false);
  const [loading, setLoading] = useState(true);
  const [providerName, setProviderName] = useState(null);
  const [userInfo, setUserInfo] = useState(null);
  const [clientInfo, setClientInfo] = useState(null);
  const [filtre, setFiltre] = useState("ouvert");
  const [toast, setToast] = useState({
    visible: false,
    type: 'success',
    message: '.',
  });

  useEffect(() => {
    setClientInfo(client);
  }, [client]);

  const logOut = useCallback(async () => {
    try {
      await fetch(window.API_URL + '/extranet/deconnexion', {
        method: 'POST',
        credentials: 'include',
      });
    } catch (e) {
      console.error('Erreur lors de la déconnexion :', e);
    }
    setIsConnected(false);
    setProviderName(null);
    setUserInfo(null);
    localStorage.removeItem('client_id');
    localStorage.removeItem('userName');
    setToast({
      visible: true,
      type: 'success',
      message: 'Déconnexion réussie',
    });
  }, []);

  const checkSession = useCallback(async () => {
    const clientId = localStorage.getItem('client_id');
    const userName = localStorage.getItem('userName');

    if (!clientId) {
      setIsConnected(false);
      setProviderName(null);
      setUserInfo(null);
      setLoading(false);
      return;
    }

    try {
      const data = await fetchClient(clientId);
      if (!data) {
        setIsConnected(false);
        setProviderName(null);
        setUserInfo(null);
        setLoading(false);
        return;
      }
      setUserInfo({ userName, idEntreprise: clientId });
      setIsConnected(true);
    } catch (error) {
      console.error('Erreur lors de la vérification de session :', error);
      setIsConnected(false);
      setProviderName(null);
      setUserInfo(null);
    } finally {
      setLoading(false);
    }
  }, [fetchClient]);

  useEffect(() => {
    checkSession();
  }, []);

  return (
    <AuthContext.Provider value={{
      isConnected,
      loading,
      providerName,
      userInfo,
      logOut,
      setToast,
      toast,
      clientInfo,
      setIsConnected,
      setProviderName,
      checkSession,
      filtre,
      setFiltre
    }}>
      {children}
    </AuthContext.Provider>
  );
};
